import * as React from "react";
import useStyles from "./WidgetPanel.styles";
import { FontAwesomeIcon } from "../../shared/FontAwesome";

interface Props {
    title: string;
    searchable?: boolean;
    search?: string;
    setSearch?(value: string): void;
    searchPlaceholder?: string;
    containerRef: React.Ref<HTMLDivElement>;
    children: React.ReactNode;
}

export default function WidgetPanel({
    title,
    searchable,
    search,
    setSearch,
    searchPlaceholder,
    containerRef,
    children,
}: Props) {
    const classes = useStyles({});
    return (
        <div className={classes.panelContainer}>
            <h4 className={classes.title}>{title}</h4>
            {searchable && (
                <div className={classes.search}>
                    <span className={classes.searchIcon}>
                        <FontAwesomeIcon icon={["fas", "search"]} />
                    </span>
                    <input
                        className={classes.searchInput}
                        value={search}
                        onChange={(e) => setSearch(e.target.value)}
                        type="search"
                        placeholder={searchPlaceholder}
                    />
                </div>
            )}
            <div className={classes.scrollable} ref={containerRef}>
                {children}
            </div>
        </div>
    );
}

interface SectionProps {
    title: string;
    children: React.ReactNode;
}

WidgetPanel.Section = function WidgetPanelSection({ title, children }: SectionProps) {
    const classes = useStyles({});
    return (
        <>
            <h4 className={classes.sectionTitle}>{title}</h4>
            {children}
        </>
    );
};
